module.exports = "/assets/private-cameras/auth.html";